/**
 * @generated SignedSource<<afc8999b1da2f7afb0de0e66d22c3314>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PackageStatus = "DRAFT" | "EXPIRED" | "PUBLISHED" | "WAITING";
import { FragmentRefs } from "relay-runtime";
export type PackageStatus_package$data = {
  readonly status: PackageStatus;
  readonly " $fragmentType": "PackageStatus_package";
};
export type PackageStatus_package$key = {
  readonly " $data"?: PackageStatus_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageStatus_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageStatus_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "0849124fb1c6a65d5a510327bc8f1832";

export default node;
